import { forwardRef } from 'react';

import { iconProps } from 'humanity/icons/index.types';

const CheckCircle = forwardRef(({ color = '#022A4D', size = 24, ...props }, ref) => (
  <svg
    ref={ref}
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    stroke={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.6355 12.5057V13.1354C19.6337 16.134 17.6599 18.7743 14.7844 19.6245C11.9089 20.4747 8.81661 19.3323 7.18454 16.8168C5.55247 14.3012 5.76937 11.0118 7.71762 8.73238C9.66587 6.45294 12.8814 5.72644 15.6203 6.94686"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3132 7.04175L12.8652 14.4897L10.834 12.4584"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

CheckCircle.displayName = 'CheckCircle';

CheckCircle.propTypes = {
  ...iconProps,
};

export default CheckCircle;
